import { FC, useMemo } from 'react';
import { Button, ButtonContentWithLoader } from '@edikk-edikk/country-layout-black';
import { useClassNamesWithStyle, useIsFrontendStyleDefault } from '@edikk-edikk/country-frontend';
import { useMenuButtonVariant, useFavoriteToggleContext, useFavoriteToggleHandlerClick } from '#baseMenu/components';
import { useAdvertFavoriteVisibleControl } from '#advertFavorite/hooks';
import { useMenuState } from '#baseMenu/hooks';
import menuControlsActionCss from '../../../assets/menu-controls-action.module.scss';
import { AppSvgSpriteMonoIcon } from '#src/svg';

const FavoriteToggleButton: FC = () => {
  const { isOpen } = useAdvertFavoriteVisibleControl();
  const { isLoadInProcess } = useFavoriteToggleContext();
  const { isActionsBlocked } = useMenuState();
  const handlerClick = useFavoriteToggleHandlerClick();
  const ariaLabel = useMemo(() => (isOpen ? 'Close favorite' : 'Open favorite'), [isOpen]);
  const isFrontendStyleDefault = useIsFrontendStyleDefault();
  const classNamesWithStyle = useClassNamesWithStyle();
  const buttonVariant = useMenuButtonVariant(isOpen);

  return (
    <Button
      variant={buttonVariant}
      circle
      onClick={handlerClick}
      aria-label={ariaLabel}
      pointerEventsNone={isActionsBlocked}
    >
      <ButtonContentWithLoader
        isLoading={isLoadInProcess}
        content={(
          <AppSvgSpriteMonoIcon
            name={isFrontendStyleDefault ? 'heart-stroke' : 'heart-fill'}
            size={20}
            className={classNamesWithStyle(
              menuControlsActionCss.menuControlsAction__icon,
              null,
              menuControlsActionCss.menuControlsAction__icon_styleRed,
            )}
          />
        )}
      />
    </Button>
  );
};

export { FavoriteToggleButton };
